import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button, Divider } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../../common/helpers/ApiHelper';
import { UiHelper } from '../../common/helpers/UiHelper';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppTheme } from '../../styles/AppTheme';
import { AppHelper } from '../../helpers/AppHelper.js'

export class EventList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if(!this.props.eventsReady || !this.props.data) {
      return (
        <div className={css(Styles.progressContainer)}>
          <CircularProgress size={48} className={css(Styles.progress)} />
        </div>
      )
    }
    if(this.props.data && this.props.data.length === 0) {
      return (
        <div className={css(Styles.progressContainer)}>
          <p>No events found.</p>
        </div>
      )
    }
    return (
      <div className={css(Styles.eventListContainer)}>
        {this.props.data.map((item,index) => {
          return (
            <div onClick={e => this.props.eventDialog(item,index)} className={css(Styles.eventInnerContainer)}>
              <div className={css(Styles.eventListInnerContainer)}>
                <div className={css(Styles.eventListImageConatiner)}>
                  <img src={item.image}
                    className={css(Styles.eventImg)}></img>
                </div>
                <div className={css(Styles.eventListTitleConatiner)}>
                  <p className={css(Styles.eventListTitle)}>{item.name}</p>
                  <p className={css(Styles.eventListDate)}>{moment(item.event_time).format('MMM DD, YYYY, h:mm:ss A')}</p>
                </div>
                <div className={css(Styles.eventTypeConatiner)}>
                  <div className={css(Styles.eventTypeContent,Styles.eventTypeCss)}>
                    {item.type &&
                    <div className={css(Styles.eventType)}>{item.type}</div>
                    }
                  </div>
                  <div className={css(Styles.eventTypeContent)}>
                    <div className={css(Styles.eventTypePriority)}
                      style={{ backgroundColor: AppHelper.getPriotiyColor(item.priority) }}>
                      {AppHelper.getPriorityStr(item.priority)}</div>
                  </div>
                </div>
              </div>
              <Divider />
            </div>
          )
        })}
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 300
  },
  eventListContainer: {
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '70vh',
    overflow: 'scroll',
  },
  eventInnerContainer: {
    cursor: 'pointer',
    ':hover' : {
      backgroundColor:AppTheme.secondaryBg
    }
  },
  eventListInnerContainer: {
    display: 'flex',
    padding: 8,
    overflow: 'hidden'
  },
  eventListImageConatiner: {
    width: 100,
    /*height: 50,*/
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'black'
  },
  eventImg: {
    width: '100%'
    /*maxWidth: '100%',
    maxHeight: '100%',*/
  },
  eventListTitleConatiner: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    marginLeft: 10,
    marginright: 10,
    justifyContent: 'center'
  },
  eventListTitle: {
    margin: 0,
    marginBottom: 5,
    fontSize: 15,
    fontWeight: 'bold'
  },
  eventListDate: {
    margin: 0,
    fontSize: 13,
    fontWeight: 600
  },
  eventTypeConatiner: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    //flex: 1
  },
  eventTypeContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    minHeight: 28
  },
  eventTypeCss: {
    marginBottom: 5
  },
  eventType: {
    backgroundColor: '#FF4081',
    color: 'white',
    borderRadius: 15,
    fontSize: 11,
    padding: 7,
  },
  eventTypePriority: {
    borderRadius: 15,
    fontSize: 11,
    padding: 7,
    color: 'white',
    fontWeight: 'bold'
  },

})



// WEBPACK FOOTER //
// ./src/common/components/EventList.js